module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "dedication",
    attrs: {
      "epub:type": "dedication"
    }
  }, [_c('p', {
    staticClass: "firstInSection"
  }, [_vm._v("For Ivan and Barbara.")]), _vm._v(" "), _c('p', [_vm._v("Thank you for all your support and kind comments.")]), _vm._v(" "), _c('p', [_vm._v("You’re two very special people.")]), _vm._v(" "), _c('p', [_vm._v("Stay well. Be good (well, at least try!).")]), _vm._v(" "), _c('p', [_vm._v("See ya, kiddos!")]), _vm._v(" "), _c('p', [_vm._v("Not forgetting our Madge who has been through a bad time but keeps plodding on – like the good ’un she is.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 66
// module chunks = 0